import React from 'react';
import UpdateExpirationCardsView from "./UpdateExpirationCardsView";
import TaskUpdateExpirationCards from "../ws/TaskUpdateExpirationCards";

export interface ResponseCSV {
    success: boolean
    message: string | null
    error: string | null
}

interface state {
    file: File | null
    response: ResponseCSV | null
}

class UpdateExpirationCardsContainer extends React.Component {

    public state: state = {file: null, response: null};

    public importCSV(file: File, stopLoading: () => void) {
        new TaskUpdateExpirationCards().get(file)
            .catch(
                (response) => {
                    this.setState({response: {success:false, error: response.message} as ResponseCSV});
                }
            )
            .then(
                (response) => {
                    if (response !== undefined) {
                        this.setState({response: response});
                    }
                    stopLoading();
                }
            )
    }

    public render() {
        return <UpdateExpirationCardsView
            importCSV={this.importCSV.bind(this)}
            response={this.state.response}
        />;
    }

}

export default UpdateExpirationCardsContainer;